import React, { Component } from "react";
import { Nav, NavItem } from 'react-bootstrap';
import { Route, Switch } from 'react-router';
import { Link } from "react-router-dom";
import LeadsService from '../utils/LeadsService';
import UsersService from '../utils/UsersService';
import List from "./List";

class ListView extends Component {
  constructor(props) {
    super(props);
    const { view } = props.match.params
    this.state = {
      users: [],
      stats: {},
      activeView: view
    };
  }

  componentDidMount() {
    this.setState({ loadingInProgress: true });
    this.fetchPeople();
    this.fetchStats()
  }

  fetchPeople() {
    UsersService.allUsers().then(data => {
      this.setState({ users: data, loadingInProgress: false })
    });
  }

  fetchStats() {
    LeadsService.stats().then(data => {
      this.setState({ stats: data });
    });
  }

  handleSelect = (eventKey) => {
    this.setState({ activeView: eventKey }, () => {
    });
  }

  render() {
    const { stats } = this.state;

    return (
      <div>
        <h3 className="first-title">Follow Ups</h3>

        <div className="row">
          <div className="col-sm-12">
            <Nav bsStyle="tabs" activeKey={this.state.activeView}
              onSelect={this.handleSelect.bind(this)}>
              <NavItem eventKey='today' componentClass={Link} to="/m1/follow_ups/list/today" href="/m1/follow_ups/list/today">Today <span>({stats.today || 0})</span></NavItem>
              <NavItem eventKey='no_due_date' componentClass={Link} to="/m1/follow_ups/list/no_due_date" href="/m1/follow_ups/list/no_due_date">No Due Date <span>({stats.no_due_date || 0})</span></NavItem>
              <NavItem eventKey='week_ahead' componentClass={Link} to="/m1/follow_ups/list/week_ahead" href="/m1/follow_ups/list/week_ahead">Week Ahead <span>({stats.week_ahead || 0})</span></NavItem>
              <NavItem eventKey='month_ahead' componentClass={Link} to="/m1/follow_ups/list/month_ahead" href="/m1/follow_ups/list/month_ahead">Month Ahead <span>({stats.month_ahead || 0})</span></NavItem>
              <NavItem eventKey='overdue' componentClass={Link} to="/m1/follow_ups/list/overdue" href="/m1/follow_ups/list/overdue"><span className={stats.overdue && stats.overdue > 0 && 'text-danger'}>Overdue ({stats.overdue || 0})</span></NavItem>
              <NavItem eventKey='unassigned' componentClass={Link} to="/m1/follow_ups/list/unassigned" href="/m1/follow_ups/list/unassigned"><span className={stats.unassigned && stats.unassigned > 0 && 'text-danger'}>Unassigned ({stats.unassigned || 0})</span></NavItem>
              <NavItem eventKey='open' componentClass={Link} to="/m1/follow_ups/list/open" href="/m1/follow_ups/list/open">All Open ({stats.open || 0})</NavItem>
              <NavItem eventKey='complete' componentClass={Link} to="/m1/follow_ups/list/complete" href="/m1/follow_ups/list/complete">Completed ({stats.complete || 0})</NavItem>
            </Nav>
            <div className="tab-content">
              <Switch>
                <Route path={'/m1/follow_ups/list/:view'} render={(props) => <List users={this.state.users} view={this.state.activeView} {...props} />} />
              </Switch>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ListView